import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../core';
import { PayCategoriesService } from '../../pay-categories/pay-categories.service';
import { INote, INoteDialogModalData } from '../../pay-categories/pay-categories.type';

/**
 * dialog for pilotpay
 */
@Component({
	selector: 'app-pilotpay-notedialog',
	styleUrls: ['./notedialog.component.scss'],
	templateUrl: './notedialog.component.html'
})
export class NoteDialogComponent {
	constructor(
		dialogRef: MatDialogRef<NoteDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		{
			payCategoryNoteSettingId,
			createdDate,
			effectiveStart,
			lastModifiedDate,
			payCategoryNoteSettingsRecordId,
			lastModifiedByUserId,
			payCategoryId,
			name,
			fieldType,
			pickListItems,
			isRequired,
			existingNotes,
			noteRowIndex,
			isEdit
		}: INoteDialogModalData,
		alertService: AlertService,
		payCategoriesService: PayCategoriesService
	) {
		this.dialogRef = dialogRef;
		if (payCategoryId) {
			this.payCategoryId = payCategoryId.toString();
		}
		this.existingNotes = existingNotes;
		this.alertService = alertService;
		this.payCategoriesService = payCategoriesService;
		this.noteRowIndex = noteRowIndex;
		this.payCategoryNote = this.getNote(
			payCategoryNoteSettingId,
			name,
			fieldType,
			pickListItems,
			isRequired,
			createdDate,
			payCategoryNoteSettingsRecordId,
			effectiveStart,
			lastModifiedByUserId,
			lastModifiedDate,
			isEdit
		);
	}

	public existingNotes: INote[] = [];
	public pickListItem: string = '';
	public payCategoriesService: PayCategoriesService;
	public dialogRef: MatDialogRef<NoteDialogComponent>;
	public alertService: AlertService;
	public payCategoryId: string;
	public payCategoryNote: INote;
	public duplicateNoteNameError: string = '';
	public noteRowIndex: number;

	public addPayCategoryNote(): void {
		if (!this.checkDuplicateNoteNames()) {
			this.dialogRef.close(this.payCategoryNote);
		}
	}

	public checkDuplicateNoteNames(): string {
		this.duplicateNoteNameError = null;
		const existingRecordIndex: number = this.existingNotes.findIndex(
			(item: INote) => item.name.toLowerCase() === this.payCategoryNote.name.toLowerCase()
		);
		// This checks for both when adding new notes or updating old notes
		if (existingRecordIndex >= 0 && this.noteRowIndex === existingRecordIndex) {
			return null;
		}
		if (
			existingRecordIndex >= 0 &&
			((this.noteRowIndex !== existingRecordIndex &&
				this.existingNotes[existingRecordIndex].payCategoryNoteSettingId !==
					this.payCategoryNote.payCategoryNoteSettingId) ||
				(this.payCategoryNote.payCategoryNoteSettingId === 0 &&
					this.existingNotes[existingRecordIndex].payCategoryNoteSettingId === 0))
		) {
			this.duplicateNoteNameError = `A note with the name ${this.payCategoryNote.name} already exists`;
		}

		return this.duplicateNoteNameError;
	}

	public isValidPickList(): boolean {
		let condition: boolean = true;

		if (this.payCategoryNote) {
			condition = true;
		}
		if (this.payCategoryNote.fieldType === 'PickList') {
			condition = false;
		}

		if (this.payCategoryNote.pickListItems && this.payCategoryNote.pickListItems.length > 0) {
			condition = true;
		}

		return condition;
	}

	/**
	 * updatePayCategoryNote
	 */
	public updatePayCategoryNote(): void {
		if (!this.checkDuplicateNoteNames()) {
			this.dialogRef.close(this.payCategoryNote);
		}
	}

	public onFieldTypeChange(): void {
		if (this.payCategoryNote.fieldType !== 'PickList') {
			this.payCategoryNote.pickListItems = null;
			this.pickListItem = '';
		} else {
			this.payCategoryNote.pickListItems = [];
		}
	}

	public addNote(): void {
		if (this.pickListItem) {
			this.payCategoryNote.pickListItems.push(this.pickListItem);
			this.pickListItem = '';
		}
	}

	public getNote(
		payCategoryNoteSettingId: number,
		name: string,
		fieldType: string,
		pickListItems: string[],
		isRequired: boolean,
		createdDate: string,
		payCategoryNoteSettingsRecordId: number,
		effectiveStart: string,
		lastModifiedByUserId: number,
		lastModifiedDate: string,
		isEdit: boolean = false
	): INote {
		const note: INote = {
			name: name,
			payCategoryNoteSettingId: payCategoryNoteSettingId,
			fieldType: fieldType,
			pickListItems: pickListItems,
			isRequired: isRequired,
			createdDate: createdDate,
			payCategoryNoteSettingsRecordId: payCategoryNoteSettingsRecordId,
			effectiveStart: effectiveStart,
			lastModifiedByUserId: lastModifiedByUserId,
			lastModifiedDate: lastModifiedDate,
			isEdit: isEdit,
			order: this.noteRowIndex
		};

		return note;
	}

	public clearNote(index: number): void {
		this.payCategoryNote.pickListItems.splice(index, 1);
	}

	public close(): void {
		this.dialogRef.close();
	}
}
